<template>
  <v-row no-gutters>
    <v-col>
      <v-row>
        <v-toolbar dense flat color="white" height="45px" class="mt-1">
          <v-toolbar-title class="headline primary--text">Geography</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn
              text
              :color="active == 'admincountry' ? 'primary darken-4' : 'primary'"
              class="font-weight-bold px-0 mr-2"
              @click="onClick('admincountry')"
            >
              <v-icon size="18" class="mr-1">mdi-earth</v-icon>COUNTRIES
            </v-btn>

            <v-divider vertical inset class="mx-1"></v-divider>

            <v-btn
              text
              :color="active == 'adminport' ? 'primary darken-4' : 'primary'"
              class="font-weight-bold px-0 mr-2"
              @click="onClick('adminport')"
            >
              <v-icon size="18" class="mx-1">mdi-airport</v-icon>PORTS
            </v-btn>

            <v-divider vertical inset class="mx-1"></v-divider>

            <v-btn
              text
              :color="active == 'admincity' ? 'primary darken-4' : 'primary'"
              class="font-weight-bold px-0 mx-2"
              @click="onClick('admincity')"
            >
              <v-icon size="18" class="ml-1">mdi-city</v-icon>CITIES
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </v-row>

      <v-row>
        <v-divider class="my-0 py-0"></v-divider>
      </v-row>

      <v-row no-gutters>
        <v-col>
          <router-view />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      active: "admincountry",
    }
  },

  async created() {
    // verify user token
    await this.$root.verify_user_token()
  },

  mounted() {
    var name = null
    this.$router.push({ name: "admincountry" })
  },

  methods: {
    onClick(routeName) {
      this.active = routeName
      var name = null
      this.$router.push({ name: routeName })
    },
  },
}
</script>

<style></style>
